import React from 'react'
import { NavLink } from 'react-router-dom';
import './Cards.css'
import cpp from '../assets/C-PartB.jpg'
import py from '../assets/Python.jpg'
import C from '../assets/C.png'
import java from '../assets/Java.jpg'
import Button from '@material-ui/core/Button';
import idea from '../assets/idea.jpg'
import puzz from '../assets/Quiz.jpeg'
import int from '../assets/interview.jpg'
import road from '../assets/roadmap.jpeg'
import puzzel from '../assets/puzz.jpg'
import Ds from '../assets/Dstruc.jfif'
import Algo from '../assets/Algo.webp'
const Cards = () => {

    return (
        <div>
        <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
<div class="card 1">
  <div class="card_image"> <img src={C}/> </div>
  <div class="card_title title-white">
    <p>C</p>
    <NavLink target='_blank' to='./category/c'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div>
</div>

  <div class="card 2">
  <div class="card_image">
    
    <img src={py} />
    </div>
  <div class="card_title title-white">
    <p>Python</p>
    <NavLink target='_blank' to='./category/python'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div>
</div>

<div class="card 1">
  <div class="card_image">
    <img src={cpp} />
  </div>
  <div class="card_title">
      <p>C++</p>
      <NavLink target='_blank' to='./category/cpp'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div>
</div>
  
  <div class="card 2">
  <div class="card_image">
    <img src={java} />
    </div>
  <div class="card_title title-black">
    <p>Java</p>
    <NavLink target='_blank' to='./category/java'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div>
  </div>
 
  </div>
        <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
  
<div class="card 3">
  <div class="card_image"> <img src={puzzel} /> </div>
  <div class="card_title title-white">
    <p>Puzzels</p>
    <NavLink target='_blank' to='./category/Puzzels'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div>
</div>

  <div class="card 4">
  <div class="card_image">
    <img src={int} />
    </div>
  <div class="card_title title-white">
    <p>Interview Question</p>
    <NavLink target='_blank' to='./category/Interview question'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div>
</div>

<div class="card 3">
  <div class="card_image">
    <img src={road} />
  </div>
  <div class="card_title">
      <p>Road-Map</p>
      <NavLink target='_blank' to='/category/Roadmaps for differnt carrers'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div>
</div>
<div class="card 3">
  <div class="card_image">
    <img src={Ds} />
  </div>
  <div class="card_title">
      <p>Data Structure</p>
      <NavLink  to='/category/Data Structure'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button> </NavLink>
  </div>
</div>
{/* <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
<div class="card 3">
  <div class="card_image">
    <img src={Algo} />
  </div>
  <div class="card_title">
      <p>Algorithm</p>
      <NavLink target='_blank' to='/category/Algorithm'>
  <Button  variant="contained" color="primary" >
        Dive-In
      </Button></NavLink>
  </div> 
</div>
</div>
   */}
 
  </div>
</div>
    )
}

export default Cards
